module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "deleterequirementmodal",
    attrs: {
      "id": _vm.modalId,
      "title": _vm.requirements.length > 1 ? ("Are you sure you want to delete " + (_vm.requirements.length) + " requirements?") : 'Are you sure you want to delete this requirement?',
      "name": "delete-requirement-modal",
      "size": "lg",
      "busy": _vm.loading,
      "ok-title": "Delete",
      "close-title": "Cancel",
      "hide-header-close": ""
    },
    on: {
      "ok": _vm.handleOk
    }
  }, [_vm._v("\n  This action can not be undone\n  "), (_vm.loading) ? _c('div', {
    attrs: {
      "slot": "modal-ok"
    },
    slot: "modal-ok"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": ""
    }
  }), _vm._v(" Deleting\n  ")], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d92660c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/DeleteRequirementModal.vue
// module id = 1023
// module chunks = 1